import { createEventBus } from "@core/features/eventBus";
import type { QuizQuestionAnswer } from "./quiz.types";

export type QuizEvents = {
  "quiz:started": { quizId: string };

  "quiz:answer:submitted": {
    questionId: number;
    answer: QuizQuestionAnswer;
    quizId: number;
    responseId: number;
  };

  "quiz:completed": { quizId: number; invitationId: number };
};

export const quizEventBus = createEventBus<QuizEvents>();

